/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import BrandLogo from '../BrandLogo';
import SecureCheckout from './Partials/SecureCheckout';
import BreadcrumbMobile from './Partials/BreadcrumbMobile/BreadcrumbMobile';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import CheckoutBanner from '../CheckoutHeaderFood/Partials/CheckoutBanner/CheckoutBanner';

const CheckoutMobileHeader = ({
    classes, onClick, currentTab,
    isPlaceOrder, brand, withLink,
    modalContent, isOpen,
    onCloseModal, btnClose,
    isAddOnWrapUp, isUniversal,
}) => {
    useEffect(() => {
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const rootElem = document.querySelector('#appshell-container');
            if (rootElem) {
                rootElem.setAttribute('style', 'padding-top: 0px; position: static');
            }
        }
    });
    return (
        <Grid
            container
            title="Secure Checkout"
            className={classes.root}
        >
            <Grid item xs={12} className={classes.mobileHeaderBlock}>
                <div className={classes.secureCheckout}>
                    <SecureCheckout isUniversal={isUniversal} />
                </div>
                <div className={classes.brandLogo}>
                    <Button
                        id="btn-logo-brand"
                        data-test="btn-logo-brand"
                        name="logoBrandButton"
                        className={classes.logoBrandBtn}
                        onClick={onClick}
                    >
                        <BrandLogo withLink={withLink} brand={brand} deviceType="mobile" />
                    </Button>
                </div>
            </Grid>
            {
                isUniversal
            && !['cart', 'confirmation'].includes(currentTab)
                    ? <Grid container className={classes.rootCheckoutHeader}><CheckoutBanner isUniversal={isUniversal} /></Grid>
                    : null
            }
            <Grid item xs={12} className={classes.navProgress}>
                {!isAddOnWrapUp && currentTab &&  <BreadcrumbMobile active={currentTab} isPlaceOrder={isPlaceOrder} />}
            </Grid>
            <ModalWrapper
                modalTitle="LEAVE CHECKOUT"
                modalContent={modalContent}
                isOpen={isOpen}
                onCloseModal={onCloseModal}
                btnClose={btnClose}
            />
        </Grid>
    );
};

CheckoutMobileHeader.propTypes = {
    classes: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    modalContent: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    btnClose: PropTypes.bool.isRequired,
    isAddOnWrapUp: PropTypes.bool.isRequired,
    isPlaceOrder: PropTypes.bool.isRequired,
    withLink: PropTypes.bool.isRequired,
    brand: PropTypes.string.isRequired,
    currentTab: PropTypes.string,
    isUniversal: PropTypes.bool,

};
CheckoutMobileHeader.defaultProps = {
    currentTab: null,
    isUniversal: false,
};

export default (CheckoutMobileHeader);
